export default __webpack_public_path__ + "static/media/ic_coin.39537c36.svg";